import { render, staticRenderFns } from "./HistoryNotificationTranslation.vue?vue&type=template&id=58ba0a1e"
import script from "./HistoryNotificationTranslation.vue?vue&type=script&lang=ts"
export * from "./HistoryNotificationTranslation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports